import { useQuery } from "@tanstack/react-query";

import { query } from "@/queries";

import { NotFoundView } from "./NotFoundView";

export function NotFoundPage() {
  const { data: user } = useQuery(query.user.me());
  return <NotFoundView signedIn={Boolean(user)} />;
}
